<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group-template *formationGroup="{title: 'wbo.period-schedule.edit.formation.details', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control [(ngModel)]="model.data.name"
                                                   formControlName="name"></wbo-text-edit-control>
                            <wbo-checkbox-edit-control formControlName="enabled"
                                                       [(ngModel)]="model.data.enabled"></wbo-checkbox-edit-control>
                        </fui-append-field>
                        <wbo-checkbox-edit-control formControlName="showAsVenueStatus"
                                                   [(ngModel)]="model.data.showAsVenueStatus"></wbo-checkbox-edit-control>
                        <fui-column *ngIf="model.data.showAsVenueStatus" [label]="'wbo.period-schedule.edit.field-set.venueStatus'">
                            <wbo-checkbox-edit-control *ngIf="model.data.showAsVenueStatus" formControlName="showOnlyWhenScheduled"
                                                       [(ngModel)]="model.data.showOnlyWhenScheduled"></wbo-checkbox-edit-control>
                            <wbo-text-edit-control [(ngModel)]="model.data.venueStatusLabel"
                                                   formControlName="venueStatusLabel"
                                                   [placeholder]="'\'' + model.data.name + '\''"></wbo-text-edit-control>
                            <wbo-checkbox-edit-control formControlName="venueStatusSwitchable"
                                                       [(ngModel)]="model.data.venueStatusSwitchable"></wbo-checkbox-edit-control>
                            <ng-container *ngIf="model.data.venueStatusSwitchable">
                                <wbo-boolean-radio-edit-control [trueLabel]="'wbo.period-schedule.edit.field.venueStatusDefault.true'"
                                                                [falseLabel]="'wbo.period-schedule.edit.field.venueStatusDefault.false'"
                                                                [(ngModel)]="model.data.venueStatusDefault"
                                                                formControlName="venueStatusDefault"></wbo-boolean-radio-edit-control>
                                <wbo-checkbox-edit-control formControlName="resetAtStartOfDay"
                                                           [(ngModel)]="model.data.resetAtStartOfDay"></wbo-checkbox-edit-control>
                                <fui-inline-information *ngIf="!isScheduled"
                                                        [title]="'wbo.common.info.information'"
                                                        [message]="'wbo.period-schedule.edit.message.venueStatus'">
                                </fui-inline-information>
                                <fui-inline-information *ngIf="isScheduled"
                                                        [title]="'wbo.common.info.information'"
                                                        [message]="'wbo.period-schedule.edit.message.venueStatusScheduled'">
                                </fui-inline-information>
                            </ng-container>
                        </fui-column>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="showAdvancedContent || model.data.overallRule.hasCriteria">
                <fui-two-columns>
                    <fui-column [label]="'wbo.period-schedule.edit.field-set.overallRule'">
                        <wbo-period-schedule-rule-edit [rule]="model.data.overallRule" [rulesPath]="'overallRule'"
                                                       [deletable]="false"
                                                       [readonly]="editPage.editMode === EditMode.VIEW"></wbo-period-schedule-rule-edit>
                        <div class="rules-conjunction">{{'wbo.common.label.and' | translate}}</div>
                    </fui-column>
                    <fui-column>
                        <fui-inline-information
                            [title]="'wbo.common.info.information'"
                            [message]="'wbo.period-schedule.edit.message.overallRule'">
                        </fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-inline-information
                    *ngIf="model.data.overallRule.hasCriteria"
                    [title]="'wbo.common.info.information'"
                    [message]="'wbo.period-schedule.edit.message.periodsAndOverallRule'">
                </fui-inline-information>
                <fui-inline-information
                    *ngIf="showPeriodsInfo && !model.data.overallRule.hasCriteria && (model.data.activeRules?.length || model.data.inactiveRules?.length)"
                    [title]="'wbo.common.info.information'"
                    [message]="'wbo.period-schedule.edit.message.periodsOnly'">
                </fui-inline-information>
                <fui-inline-information
                    *ngIf="showPeriodsInfo && !model.data.overallRule.hasCriteria && !model.data.activeRules?.length && !model.data.inactiveRules?.length"
                    [title]="'wbo.common.info.information'"
                    [message]="'wbo.period-schedule.edit.message.noPeriods'">
                </fui-inline-information>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-row [label]="'wbo.period-schedule.edit.formation.active-periods'">
                            <fui-content-layout-header-control slot="after">
                                <div class="rules-header">
                                    <fui-header-button *ngIf="editPage.editMode !== EditMode.VIEW"
                                                       [title]="'wbo.period-schedule.edit.button.addPeriod'"
                                                       (click)="addRule(model.data.activeRules)"></fui-header-button>
                                </div>
                            </fui-content-layout-header-control>
                            <fui-rows>
                                <fui-rows *ngFor="let rule of model.data.activeRules; let i = index">
                                    <div class="rules-conjunction" *ngIf="i > 0">{{'wbo.common.label.or' | translate}}</div>
                                    <fui-row>
                                        <wbo-period-schedule-rule-edit [rule]="rule" [rulesPath]="'activeRules'"
                                                                       [readonly]="editPage.editMode === EditMode.VIEW"
                                                                       (onDelete)="deleteRule(model.data.activeRules, rule)"></wbo-period-schedule-rule-edit>
                                    </fui-row>
                                </fui-rows>
                            </fui-rows>
                        </fui-row>
                    </fui-column>
                    <fui-column>
                        <fui-row [label]="'wbo.period-schedule.edit.formation.inactive-periods'">
                            <fui-content-layout-header-control slot="after">
                                <div class="rules-header">
                                    <fui-header-button *ngIf="editPage.editMode !== EditMode.VIEW"
                                                       [title]="'wbo.period-schedule.edit.button.addPeriod'"
                                                       (click)="addRule(model.data.inactiveRules)"></fui-header-button>
                                </div>
                            </fui-content-layout-header-control>
                            <fui-rows>
                                <fui-rows *ngFor="let rule of model.data.inactiveRules; let i = index">
                                    <div class="rules-conjunction" *ngIf="i > 0">{{'wbo.common.label.or' | translate}}</div>
                                    <fui-row>
                                        <wbo-period-schedule-rule-edit [rule]="rule" [rulesPath]="'inactiveRules'"
                                                                       [readonly]="editPage.editMode === EditMode.VIEW"
                                                                       (onDelete)="deleteRule(model.data.inactiveRules, rule)"></wbo-period-schedule-rule-edit>
                                    </fui-row>
                                </fui-rows>
                            </fui-rows>
                        </fui-row>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <wbo-edit-page-footer-controls>
        <wbo-switch-edit-control class="advanced-switch"
                                 [label]="'wbo.common.button.advanced'"
                                 [(value)]="pageState.advanced"
                                 (valueChange)="advancedChanged()"></wbo-switch-edit-control>
    </wbo-edit-page-footer-controls>
</wbo-edit-page>
